import { render } from "./SmChatIcon.vue?vue&type=template&id=5bed2b56&scoped=true"
const script = {}

import "./SmChatIcon.vue?vue&type=style&index=0&id=5bed2b56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bed2b56"]])

export default __exports__